
import SEOHead from '../../components/seo/SEOHead';
import SchemaOrg from '../../components/seo/SchemaOrg';

export default function About() {
  const teamMembers = [
    {
      name: "Claes Puebla Smith",
      role: "Host & Founder",
      bio: "Serial entrepreneur in the IT and a spirits industry veteran with 20+ years of experience building premium brands distribution all across Europe.",
      image: "https://static.readdy.ai/image/ad65d83c1087407616f0591309583e77/d1d1b4f9ffe1146559ce479fda200edb.jfif"
    },
    {
      name: "Greg-Emile Willybiro",
      role: "Host & Founder",
      bio: "Greg Willy Biro is a seasoned spirits industry professional and entrepreneur, specializing in premium Mexican spirits and social media with extensive experience in international market development across Europe.",
      image: "https://static.readdy.ai/image/ad65d83c1087407616f0591309583e77/217483ebad9ab5d4f1706e8df52c547f.png"
    },
    {
      name: "Gabriel Zarsoza",
      role: "Host & Founder",
      bio: "Gabriel Zarzosa is a creative producer and problem solver with a passion for storytelling, research, and innovation, bringing nearly 20 years of experience in branded and documentary multimedia content production.",
      image: "https://static.readdy.ai/image/ad65d83c1087407616f0591309583e77/444460bc5853ac28d7625e29bdadfa54.jfif"
    }
  ];

  const partners = [
    {
      name: "AliasSmith",
      description: "AliasSmith, as an Importer, connects outstanding spirits with global markets through innovative, sustainable and digitalised practices and expert brand management, making exceptional products accessible to distributors and consumers worldwide.",
      website: "https://aliassmith.com",
      services: ["Importer", "Brand Manager", "Brand Owner", "Strategy consultant", "System Developer", "Sustainable Initiatives Generator", "Investor"],
      image: "https://public.readdy.ai/ai/img_res/a1e88bcfb488fc4b9bbca6928dd01181.jpg"
    },
    {
      name: "Jumpify.net",
      description: "Jumpify streamlines logistics for beverage brands, offering reliable, launching strategies, marketing, 3PL services, administration, and distribution support across Europe, so brands can focus on growth while Jumpify handles the rest.",
      website: "https://jumpify.net",
      services: ["Complete 3PL", "Strategy Consultant", "Marketeer"],
      image: "https://readdy.ai/api/search-image?query=Modern%20technology%20startup%20office%20with%20innovative%20workspace%20digital%20transformation%20environment%20tech%20innovation%20lab%20contemporary%20business%20setting%20creative%20workspace%20design%20modern%20tech%20company%20interior&width=600&height=400&seq=jumpify-office&orientation=landscape"
    },
    {
      name: "Los Chapulines",
      description: "A shared On-Trade team operating in leading European cities, dedicated to promoting selected spirits in the hospitality sector. This team help brand owners' promotional strategy, focusing on building awareness and driving sales across Europe.",
      website: "https://loschapulines.org",
      services: ["Brand Ambassadors", "Event makers", "Business Match-Makers", "On-Trade Sales Team"],
      image: "https://readdy.ai/api/search-image?query=Community%20development%20center%20with%20collaborative%20workspace%20social%20entrepreneurship%20environment%20community%20meeting%20spaces%20sustainable%20development%20office%20grassroots%20organization%20workspace%20cooperative%20business%20setting&width=600&height=400&seq=chapulines-office&orientation=landscape"
    }
  ];

  // SEO Schema.org data for about page
  const aboutPageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About DBD Podcast",
    "description": "Learn about DBD Podcast, our mission, team, and partner companies. Where business wisdom meets the art of distillation.",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
    "mainEntity": {
      "@type": "Organization",
      "name": "DBD Podcast",
      "alternateName": "Distilled Business Dialogue",
      "description": "Premium business podcast exploring the intersection of entrepreneurship, psychology, and industry expertise through meaningful conversations with leaders.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "logo": "https://static.readdy.ai/image/ad65d83c1087407616f0591309583e77/5910930edf8f8435ab6c0a56926fd219.png",
      "founder": teamMembers.map(member => ({
        "@type": "Person",
        "name": member.name,
        "jobTitle": member.role,
        "description": member.bio,
        "image": member.image
      })),
      "partner": partners.map(partner => ({
        "@type": "Organization",
        "name": partner.name,
        "description": partner.description,
        "url": partner.website
      }))
    }
  };

  return (
    <div className="min-h-screen pt-16">
      <SEOHead
        title="About DBD Podcast | Meet Our Team & Mission"
        description="Learn about DBD Podcast, our mission to bridge business wisdom with industry expertise, meet our founding team, and discover our partner companies driving innovation across industries."
        keywords="about DBD podcast, podcast team, business podcast founders, podcast mission, AliasSmith, Jumpify, Los Chapulines, business consulting partners"
        ogTitle="About DBD Podcast | Meet Our Team & Mission"
        ogDescription="Learn about DBD Podcast, our mission, team, and partner companies. Where business wisdom meets the art of distillation."
        ogType="website"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`}
      />
      
      <SchemaOrg data={aboutPageSchema} />

      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20with%20premium%20spirits%20bottles%20and%20glasses%20sophisticated%20corporate%20atmosphere%20elegant%20business%20discussion%20luxury%20office%20setting%20executive%20networking%20environment%20warm%20ambient%20lighting&width=1920&height=600&seq=about-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-white mb-6">About DBD Podcast</h1>
            <p className="text-xl text-gray-200 leading-relaxed">
              Where business wisdom meets the art of distillation. We explore the intersection of entrepreneurship, 
              psychology, and industry expertise through meaningful conversations with leaders who've navigated 
              complex challenges and built lasting success.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-800 mb-6">Our Mission</h2>
                <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
                  <p>
                    DBD Podcast was created to bridge the gap between theoretical business knowledge and practical 
                    industry wisdom. We believe that the most valuable insights come from deep, thoughtful conversations 
                    with leaders who've faced real challenges and found innovative solutions.
                  </p>
                  <p>
                    Each episode distills complex business concepts into actionable wisdom, creating a rich dialogue 
                    that entrepreneurs, business leaders, and industry professionals can apply immediately to their 
                    own ventures and leadership journeys.
                  </p>
                  <p>
                    Through our connections with AliasSmith, Jumpify.net, and Los Chapulines, we bring diverse 
                    perspectives on strategic consulting, digital innovation, and community-driven business development.
                  </p>
                </div>
              </div>
              <div 
                className="h-96 rounded-xl bg-cover bg-center shadow-lg"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=Business%20philosophy%20concept%20with%20books%20and%20premium%20spirits%20elegant%20study%20setting%20professional%20development%20environment%20corporate%20learning%20atmosphere%20sophisticated%20business%20education%20workspace&width=600&height=500&seq=mission-image&orientation=landscape')`
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Meet Our Team</h2>
              <p className="text-xl text-gray-600">
                The voices behind the conversations that matter
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
              {teamMembers.map((member, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg p-8 text-center">
                  <div 
                    className="w-32 h-32 mx-auto mb-6 rounded-full bg-cover bg-center shadow-lg"
                    style={{ backgroundImage: `url('${member.image}')` }}
                  ></div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">{member.name}</h3>
                  <p className="text-amber-600 font-semibold mb-4">{member.role}</p>
                  <p className="text-gray-600 leading-relaxed">{member.bio}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Partner Companies Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Partner Companies</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                DBD Podcast is proudly connected with innovative companies driving change across industries. 
                These partnerships provide our listeners with exclusive insights and resources.
              </p>
            </div>

            <div className="space-y-16">
              {partners.map((partner, index) => (
                <div key={index} className={`grid lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                  <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                    <div className="flex items-center mb-6">
                      <h3 className="text-3xl font-bold text-gray-800">{partner.name}</h3>
                      <a
                        href={partner.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ml-4 text-amber-600 hover:text-amber-700 transition-colors cursor-pointer"
                      >
                        <i className="ri-external-link-line text-xl"></i>
                      </a>
                    </div>
                    <p className="text-lg text-gray-600 leading-relaxed mb-6">
                      {partner.description}
                    </p>
                    <div className="mb-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Services:</h4>
                      <div className="flex flex-wrap gap-2">
                        {partner.services.map((service, serviceIndex) => (
                          <span
                            key={serviceIndex}
                            className="bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm font-medium"
                          >
                            {service}
                          </span>
                        ))}
                      </div>
                    </div>
                    <a
                      href={partner.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      Visit {partner.name}
                    </a>
                  </div>
                  <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                    <div 
                      className="h-80 rounded-xl bg-cover bg-center shadow-lg"
                      style={{ backgroundImage: `url('${partner.image}')` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* Transparency Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-lg p-12">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-4">Transparency Disclosure</h2>
                <div className="w-16 h-1 bg-amber-500 mx-auto"></div>
              </div>
              
              <div className="space-y-6 text-gray-600 leading-relaxed">
                <p>
                  <strong className="text-gray-800">Sponsor Relationships:</strong> DBD Podcast maintains strategic 
                  partnerships with AliasSmith, Jumpify.net, and Los Chapulines. These relationships allow us to provide 
                  our listeners with exclusive insights, resources, and expertise from industry leaders.
                </p>
                <p>
                  <strong className="text-gray-800">Editorial Independence:</strong> While we value our partnerships, 
                  our editorial content remains independent. All recommendations, insights, and discussions are based 
                  on merit and relevance to our audience's interests and needs.
                </p>
                <p>
                  <strong className="text-gray-800">Value Commitment:</strong> Our primary commitment is to deliver 
                  valuable, actionable business insights to our listeners. Partner content is included only when it 
                  directly serves this mission and provides genuine value to our community.
                </p>
                <p>
                  <strong className="text-gray-800">Listener First:</strong> We believe transparency builds trust. 
                  Any sponsored content, partner recommendations, or affiliate relationships are clearly disclosed 
                  to ensure our listeners can make informed decisions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-gray-900 to-gray-800">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Join the Conversation?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Subscribe to get access to all episodes and connect with a community of business leaders and entrepreneurs
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/#subscribe"
              className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-4 px-12 rounded-lg transition-all duration-200 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Subscribe Now
            </a>
            <a
              href="/episodes"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 font-bold py-4 px-12 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Browse Episodes
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
